module.exports = __webpack_public_path__ + "img/h-page4-62.dbaf0a65.png";